module.exports = __webpack_public_path__ + "static/media/ANJ.197b8a5a.png";